import { useState } from "react";
import Box from "@mui/material/Box";
import ModalBasicLayout from "../../../components/Modal/ModalBasicLayout";
import ContainerModalActions from "../../../components/Containers/ContainerModalActions";
import TextField from "../../../components/Form/TextField";
import { useForm } from "react-hook-form";
import { useTranslationApp } from "../../../lib/i18next";
import { useDispatchApp } from "../../../lib/redux";
import { startAddCreditsToAgency } from "../../../actions/owner";
import { SimpleAlert } from "../../../components/Alerts/Alerts";
import {
  MAX_CREDITS_TO_ADD,
  MIN_CREDITS_TO_ADD,
} from "../../../utils/constants";
import {
  ADMIN_DASHBOARD_ADD_CREDITS_MODAL_LABEL,
  ADMIN_DASHBOARD_ADD_CREDITS_MODAL_MIN_ERROR,
  ADMIN_DASHBOARD_ADD_CREDITS_MODAL_MAX_ERROR,
  ADMIN_DASHBOARD_ADD_CREDITS_MODAL_PLACEHOLDER,
  ADMIN_DASHBOARD_ADD_CREDITS_MODAL_TITLE,
  ADMIN_DASHBOARD_CREDITS_ADDED_SUCCESS,
  BUTTON_CANCEL,
  BUTTON_SAVE,
  FIELD_REQUIRED,
} from "../../../i18n/keysTranslations";

const ModalAddCredits = ({
  modalOpen,
  onCloseModal,
  agencyID,
  onCallbackSave = () => {},
}) => {
  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    defaultValues: {
      credits: "",
    },
  });

  const onSubmit = async (values) => {
    if (!agencyID) return;

    setIsSubmitting(true);
    try {
      const response = await dispatch(
        startAddCreditsToAgency(agencyID, Number(values.credits))
      );

      if (response?.ok) {
        onCallbackSave(response.data);
        await SimpleAlert({
          title: t(ADMIN_DASHBOARD_CREDITS_ADDED_SUCCESS),
          icon: "success",
        });
        reset();
        onCloseModal();
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      title={t(ADMIN_DASHBOARD_ADD_CREDITS_MODAL_TITLE)}
      maxWidth="sm"
      fullWidth
      showCloseButton={true}
    >
      <Box
        component="form"
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          width: "100%",
        }}
      >
        <TextField
          fullWidth
          type="number"
          inputProps={{
            min: MIN_CREDITS_TO_ADD,
            max: MAX_CREDITS_TO_ADD,
            step: 1,
          }}
          label={t(ADMIN_DASHBOARD_ADD_CREDITS_MODAL_LABEL)}
          placeholder={t(ADMIN_DASHBOARD_ADD_CREDITS_MODAL_PLACEHOLDER)}
          name="credits"
          variant="filled"
          color="primary"
          InputLabelProps={{ shrink: true }}
          control={control}
          rules={{
            required: {
              value: true,
              message: t(FIELD_REQUIRED),
            },
            min: {
              value: MIN_CREDITS_TO_ADD,
              message: t(ADMIN_DASHBOARD_ADD_CREDITS_MODAL_MIN_ERROR, {
                min: MIN_CREDITS_TO_ADD,
              }),
            },
            max: {
              value: MAX_CREDITS_TO_ADD,
              message: t(ADMIN_DASHBOARD_ADD_CREDITS_MODAL_MAX_ERROR, {
                max: MAX_CREDITS_TO_ADD,
              }),
            },
          }}
          errors={errors}
        />

        <ContainerModalActions
          hasPadding={false}
          propsSecondaryButton={{
            showButton: true,
            text: BUTTON_CANCEL,
            onClick: onCloseModal,
          }}
          propsPrimaryButton={{
            showButton: true,
            text: BUTTON_SAVE,
            loading: isSubmitting,
            type: "submit",
            onClick: () => {},
          }}
        />
      </Box>
    </ModalBasicLayout>
  );
};

export default ModalAddCredits;
